import { For } from "solid-js";
import { Link } from "@tanstack/solid-router";
import { Brain, Clock, Folder, Receipt, Settings, Timer, TrendingUp, Users } from "@fleet/icons";
import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import { useI18n } from "@/providers/i18n-provider";

const TABS = [
  { to: "/chronos", label: msg`Dashboard`, icon: Timer, exact: true },
  { to: "/chronos/timeline", label: msg`Timeline`, icon: Clock, exact: false },
  { to: "/chronos/projects", label: msg`Projects`, icon: Folder, exact: false },
  { to: "/chronos/timesheet", label: msg`Timesheet`, icon: Receipt, exact: false },
  { to: "/chronos/deep-work", label: msg`Deep Work`, icon: Brain, exact: false },
  { to: "/chronos/analytics", label: msg`Analytics`, icon: TrendingUp, exact: false },
  { to: "/chronos/team", label: msg`Team`, icon: Users, exact: false },
  { to: "/chronos/settings", label: msg`Settings`, icon: Settings, exact: false },
] satisfies { to: string; label: MessageDescriptor; icon: unknown; exact: boolean }[];

export function ChronosControlBar() {
  const { t } = useI18n();

  return (
    <div class="fixed bottom-0 left-0 right-0 z-50 p-4 pb-[calc(1rem+var(--safe-area-inset-bottom))] flex justify-center pointer-events-none">
      <nav
        aria-label={t(msg`Chronos navigation`)}
        class="pointer-events-auto bg-surface/90 supports-[backdrop-filter]:bg-surface/70 backdrop-blur-xl border border-border/60 rounded-full px-4 py-2 shadow-2xl max-w-lg w-full flex items-center justify-around gap-1"
      >
        <For each={TABS}>
          {(tab) => (
            <Link
              to={tab.to}
              class="flex min-h-11 flex-col items-center justify-center gap-0.5 text-[10px] font-semibold py-1.5 px-3 rounded-2xl transition-[transform,color,background-color,border-color] duration-300 will-change-transform select-none text-muted-foreground hover:text-foreground hover:bg-foreground/5 active:scale-95 border border-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50"
              activeProps={{
                class:
                  "flex min-h-11 flex-col items-center justify-center gap-0.5 text-[10px] font-bold py-1.5 px-3 rounded-2xl select-none text-accent bg-accent/12 shadow-[0_0_14px_1px_var(--glow-0)] border border-accent/25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50",
              }}
              activeOptions={{ exact: tab.exact }}
            >
              <tab.icon class="h-5 w-5" />
              <span class="tracking-wide">{t(tab.label)}</span>
            </Link>
          )}
        </For>
      </nav>
    </div>
  );
}
